import { Pillar2FilingOperationStep } from '../../../model/pillar2FilingOperationStep';

/** Base filename (without extension) for submission request download. */
export const PILLAR2_SUBMISSION_FILE_PREFIX = 'pillar2-submission';

/** Base filename (without extension) for submission response download. */
export const PILLAR2_RESPONSE_FILE_PREFIX = 'pillar2-response';

export const PILLAR2_FILING_STEP_ORDER: Pillar2FilingOperationStep[] = [
    Pillar2FilingOperationStep.Submit,
    Pillar2FilingOperationStep.CloudStorage,
];
